import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [
  { path: '/', redirect: '/loading' },
  { path: '/loading', component: () => import('@/views/loading.vue'), meta: { title: '授权登录' } },
  { path: '/login', component: () => import('@/views/login.vue') },
  {
    path: '/activity',
    component: () => import('@/views/activity.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/order',
    component: () => import('@/views/order.vue'),
    meta: {
      title: '我的订单'
    }
  },
  {
    path: '/mtl',
    component: () => import('@/views/mtl.vue'),
    meta: {
      title: '摩天轮'
    }
  },
  {
    path: '/order-detail',
    component: () => import('@/views/orderdetails.vue'),
    meta: {
      title: '订单详情'
    }
  }
  // demo
  // {
  //   path: '/prize',
  //   component: () => import('@/views/prize.vue'),
  //   meta: {
  //     title: '抽奖demo'
  //   }
  // }
]
const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) { // 如果设置标题，拦截后设置标题
    document.title = to.meta.title
  }
  next()
})
export default router
